export const IS_TEST =
  window.location.href.indexOf('decko-test') !== -1 ||
  // window.location.href.indexOf('localhost') !== -1 ||
  window.location.href.indexOf('devct.cz') !== -1;

export const PATH = {
  FRAME: '//player.ceskatelevize.cz'
};

export const DEBUG_DATE = new Date('2018-07-18T10:00:00.000+01:00');

export const ACTIONS = {
  SET_START_DAY: 'SET_START_DAY',
  COLUMNS_UPDATE: 'COLUMNS_UPDATE',
  DAY_SELECT_SWITCH: 'DAY_SELECT_SWITCH',

  DAY_FETCH: 'DAY_FETCH',
  DAY_FETCH_DONE: 'DAY_FETCH_DONE',
  DAY_FETCH_ERROR: 'DAY_FETCH_ERROR'
};

export const URLS = {
  BACKEND: {
    DEBUG: 'http://localhost:5000/ct-stoleti/us-central1/',
    PUBLIC: 'https://us-central1-ct-stoleti.cloudfunctions.net/'
  },
  SERVICE: {
    GET_DAY: 'day',
    GET_ENTRY: 'entry'
  }
};

export const ROUTING = {
  HOME: '/',
  DETAIL: '/detail'
};

export const ENTRY_TYPE = {
  VIDEO: 'video',
  GALLERY: 'gallery'
};

export const YEAR = 1968;
export const START_TIME = new Date(1968, 0, 1).getTime();
export const WEEK_LENGTH = 7;
export const MS_DAY = 24 * 60 * 60 * 1000;

// todo - unify - use only one string (probably second because it's common for getDay date return function)
export const WEEKDAYS = [
  'Pondělí',
  'Úterý',
  'Středa',
  'Čtvrtek',
  'Pátek',
  'Sobota',
  'Neděle'
];
export const WEEKDAYS_EN = [
  'Neděle',
  'Pondělí',
  'Úterý',
  'Středa',
  'Čtvrtek',
  'Pátek',
  'Sobota'
];
export const MONTHS = [
  'leden',
  'únor',
  'březen',
  'duben',
  'květen',
  'červen',
  'červenec',
  'srpen',
  'září',
  'říjen',
  'listopad',
  'prosinec'
];

export const RESIZE_LIMITS = {
  COLUMNS: [[1600, 7], [1380, 6], [1150, 5], [930, 4], [700, 3], [480, 2]]
};



// WEBPACK FOOTER //
// ./src/constants.js